import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function ComplianceCenter() {
	return (
		<>
			<Helmet>
				<title>Licensing &amp; Compliance | Apex Specialty Contracting LLC</title>
				<meta name="description" content="Apex Specialty Contracting LLC holds a Florida Certified Roofing Contractor license and maintains full TCPA/SMS compliance. Learn about our credentials and communication policies." />
			</Helmet>
			<PageHeader
				title="Licensing &amp; Compliance"
				subtitle="Florida-licensed roofing contractor committed to quality work and transparent communication."
			/>
			<section className="section">
				<div className="container">
					<div className="grid">

						<div className="card" style={{ padding: 18 }}>
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 3l7 4v5c0 4-3 7.5-7 9-4-1.5-7-5-7-9V7l7-4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
									<path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</div>
							<h3>Florida Contractor License</h3>
							<p className="helper">
								Apex Specialty Contracting LLC holds Florida Certified Roofing Contractor License
								<strong> #XXXXX2536</strong>, issued by the Florida Department of Business &amp; Professional
								Regulation (DBPR). All work is performed by licensed and insured professionals.
							</p>
						</div>

						<div className="card" style={{ padding: 18 }}>
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
									<path d="M7 10h10M7 14h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
								</svg>
							</div>
							<h3>Insurance Coverage</h3>
							<p className="helper">
								We carry <strong>$2,000,000 general liability insurance</strong> and full workers' compensation
								coverage on all employees and subcontractors. Certificates of insurance are available upon request.
								Contact us at <a href="mailto:info@appexconnecthub.com">info@appexconnecthub.com</a>.
							</p>
						</div>

						<div className="card" style={{ padding: 18 }}>
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6 8h12v8H6V8Z" stroke="currentColor" strokeWidth="1.5"/>
									<path d="M10 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
									<path d="M8 4h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
								</svg>
							</div>
							<h3>SMS &amp; TCPA Compliance</h3>
							<p className="helper">
								We collect explicit written consent before sending any marketing SMS. Consent disclosures state
								message frequency, applicable rates, and STOP/HELP keywords. Consent is never required to receive
								roofing services. STOP immediately removes you from all marketing lists.
							</p>
						</div>

						<div className="card" style={{ padding: 18 }}>
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6 5h12v14H6V5Z" stroke="currentColor" strokeWidth="1.5"/>
									<path d="M9 9h6m-6 3h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
									<path d="M10 5V3m4 2V3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
								</svg>
							</div>
							<h3>Opt-Out &amp; Keywords</h3>
							<p className="helper">
								Reply <strong>STOP</strong> to any message to permanently opt out of SMS communications.
								Reply <strong>HELP</strong> for assistance info. We maintain an internal opt-out list
								in addition to carrier-level blocking. You may also opt out via our{' '}
								<Link to="/opt-out">online opt-out form</Link>.
							</p>
						</div>

						<div className="card" style={{ padding: 18 }}>
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 9h14v8H5V9Z" stroke="currentColor" strokeWidth="1.5"/>
									<path d="M9 9V7a3 3 0 0 1 6 0v2" stroke="currentColor" strokeWidth="1.5"/>
								</svg>
							</div>
							<h3>Data Privacy</h3>
							<p className="helper">
								We share your information only with providers needed to fulfill your service request (e.g., scheduling,
								insurance coordination). We do not sell personal data or mobile phone numbers to third parties for
								marketing. See our <Link to="/privacy">Privacy Policy</Link> for full details.
							</p>
						</div>

						<div className="card" style={{ padding: 18 }}>
							<div className="icon-circle">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
									<path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
								</svg>
							</div>
							<h3>Consent Records</h3>
							<p className="helper">
								Consent events are logged with timestamp, method, and referring page. Records are retained to
								demonstrate compliance with TCPA and carrier requirements. Contact{' '}
								<a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a> for consent inquiries.
							</p>
						</div>

					</div>

					<div className="card" style={{ marginTop: 32, padding: 20, background: '#f8fbfa', border: '1px solid #ddeee8' }}>
						<h3 style={{ margin: '0 0 8px' }}>Questions About Our Credentials?</h3>
						<p className="helper" style={{ margin: '0 0 12px' }}>
							You can verify our Florida contractor license on the{' '}
							<a href="https://www.myfloridalicense.com" target="_blank" rel="noopener noreferrer">
								Florida DBPR website
							</a>{' '}
							or contact us directly.
						</p>
						<Link to="/contact" className="btn">Contact Us</Link>
					</div>
				</div>
			</section>
		</>
	);
}

export default ComplianceCenter;
